(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aa-record-storage-finder"] && !Shopify.designMode) return;
  try {
    
  class AARecordStorageFinder extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.state = {
        placement: '',
        unit: 'in',
        capacity: 100,
        inputMode: 'records',
        growth: false,
        mobility: 'any',
        recordProfile: 'mixed',
        futurePlanning: false,
        monthlyGrowth: 0,
        storagePlan: 'single',
        listeningCount: 40
      };
      this.steps = [...this.querySelectorAll('[data-step]')];
      this.progress = [...this.querySelectorAll('[data-progress]')];
      this.progressShell = this.querySelector('[data-progress-shell]');
      this.progressCurrent = this.querySelector('[data-progress-current]');
      this.progressSummary = this.querySelector('[data-progress-summary]');
      this.progressSummaryText = this.querySelector('[data-progress-summary-text]');
      this.progressEdit = this.querySelector('[data-edit-choices]');
      this.currentStep = 1;
      this.workspace = this.querySelector('.aa-finder__workspace');
      this.livePanel = this.querySelector('.aa-finder__live');
      this.source = this.querySelector('.aa-finder__model-source');
      this.models = [...this.querySelectorAll('[data-model]')];
      this.capacity = this.querySelector('[data-capacity]');
      this.capacityNumber = this.querySelector('[data-capacity-number]');
      this.capacityError = this.querySelector('[data-capacity-error]');
      this.calculatorContinue = this.querySelector('[data-calculator-continue]');
      this.state.capacity = Number(this.capacity.value) || 100;
      this.inputModes = [...this.querySelectorAll('[data-input-mode]')];
      this.inputPanels = [...this.querySelectorAll('[data-input-panel]')];
      this.recordProfiles = [...this.querySelectorAll('[data-record-profile]')];
      this.state.recordProfile = this.recordProfiles.find((input) => input.checked)?.value || 'mixed';
      this.shelfLength = this.querySelector('[data-shelf-length]');
      this.shelfLengthNumber = this.querySelector('[data-shelf-length-number]');
      this.shelfError = this.querySelector('[data-shelf-error]');
      this.shelfLengthResult = this.querySelector('[data-shelf-length-result]');
      this.shelfCapacityResult = this.querySelector('[data-shelf-capacity-result]');
      this.resultLabel = this.querySelector('[data-result-label]');
      this.calculatorDisclaimer = this.querySelector('[data-calculator-disclaimer]');
      this.capacityNote = this.querySelector('[data-capacity-note]');
      this.capacityCollectionLink = this.querySelector('[data-capacity-collection-link]');
      this.futurePlanner = this.querySelector('[data-future-planner]');
      this.futurePlaceholder = this.querySelector('[data-future-placeholder]');
      this.monthlyGrowth = this.querySelector('[data-monthly-growth]');
      this.futureEmpty = this.querySelector('[data-future-empty]');
      this.futureResult = this.querySelector('[data-future-result]');
      this.futureCollectionResult = this.querySelector('[data-future-collection-output]');
      this.futureLengthResult = this.querySelector('[data-future-length-output]');
      this.recommendationTargets = [...this.querySelectorAll('[data-recommendation-target]')];
      this.currentTargetLabel = this.querySelector('[data-current-target-label]');
      this.futureTargetLabel = this.querySelector('[data-future-target-label]');
      this.mobilityField = this.querySelector('[data-mobility-field]');
      this.liveGroups = this.querySelector('[data-live-groups]');
      this.liveSummary = this.querySelector('[data-live-summary]');
      this.liveEmpty = this.querySelector('[data-live-empty]');
      this.storagePlan = this.querySelector('[data-storage-plan]');
      this.planTitle = this.querySelector('[data-plan-title]');
      this.planCopy = this.querySelector('[data-plan-copy]');
      this.planTotal = this.querySelector('[data-plan-total]');
      this.planCollectedDetail = this.querySelector('[data-plan-collected-detail]');
      this.planSingleCopy = this.querySelector('[data-plan-single-copy]');
      this.planTwoZoneLabel = this.querySelector('[data-plan-two-zone-label]');
      this.planTwoZoneCopy = this.querySelector('[data-plan-two-zone-copy]');
      this.planMain = this.querySelector('[data-plan-main]');
      this.planListening = this.querySelector('[data-plan-listening]');
      this.twoZoneButton = this.querySelector('[data-use-two-zone]');
      this.singleZoneButton = this.querySelector('[data-use-single]');
      this.placeQuestion = this.querySelector('[data-place-question]');
      this.placeHint = this.querySelector('[data-place-hint]');
      this.placementContinue = this.querySelector('[data-placement-continue]');
      this.mainResultsTitle = this.querySelector('[data-main-results-title]');
      this.listeningSize = this.querySelector('[data-listening-size]');
      this.listeningPlaceholder = this.querySelector('[data-listening-placeholder]');
      this.listeningCounts = [...this.querySelectorAll('[data-listening-count]')];
      this.advice = this.querySelector('[data-advice]');
      this.lastTrackedAdvice = '';
      this.lastTrackedResults = '';
      this.quickResults = false;
      this.bindEvents();
      this.renderCalculator();
      this.updateProgress(1);
    }

    bindEvents() {
      this.querySelectorAll('.aa-finder__place[data-placement]').forEach((button) => {
        button.addEventListener('click', () => {
          this.selectPlacement(button);
        });
      });

      this.calculatorContinue.addEventListener('click', () => {
        if (!this.validateCalculatorInput()) {
          const invalidInput = this.state.inputMode === 'records' ? this.capacityNumber : this.shelfLengthNumber;
          invalidInput.focus();
          return;
        }
        this.showStep(2);
      });

      this.placementContinue.addEventListener('click', () => {
        if (!this.state.placement || this.placementContinue.disabled) return;
        this.showStep(3);
        this.renderLiveMatches();
      });

      this.progressEdit.addEventListener('click', () => {
        this.quickResults = false;
        this.showStep(2);
      });

      this.twoZoneButton.addEventListener('click', () => {
        if (this.twoZoneButton.disabled) return;
        this.state.storagePlan = 'two-zone';
        this.state.listeningCount = this.recommendedListeningCount();
        this.listeningCounts.forEach((input) => {
          input.checked = Number(input.value) === this.state.listeningCount;
        });
        this.renderStoragePlan();
        this.renderLiveMatches();
        this.track('aa_finder_storage_plan_selected', {
          storage_plan: 'two_zone',
          capacity_band: this.capacityBand(),
          listening_count: this.state.listeningCount
        });
      });

      this.singleZoneButton.addEventListener('click', () => {
        this.state.storagePlan = 'single';
        this.renderStoragePlan();
        this.renderLiveMatches();
        this.track('aa_finder_storage_plan_selected', {
          storage_plan: 'single',
          capacity_band: this.capacityBand()
        });
      });

      this.listeningCounts.forEach((input) => {
        input.addEventListener('change', () => {
          if (!input.checked) return;
          this.state.listeningCount = Number(input.value);
          this.renderStoragePlan();
          this.renderLiveMatches();
        });
      });

      this.querySelectorAll('[data-back]').forEach((button) => {
        button.addEventListener('click', () => {
          const requestedStep = Number(button.dataset.back);
          const nextStep = this.quickResults && requestedStep === 2 ? 1 : requestedStep;
          this.quickResults = false;
          this.showStep(nextStep);
        });
      });

      this.inputModes.forEach((input) => {
        input.addEventListener('change', () => {
          if (!input.checked) return;
          this.state.inputMode = input.value;
          this.inputPanels.forEach((panel) => {
            panel.hidden = panel.dataset.inputPanel !== this.state.inputMode;
          });
          if (this.state.inputMode !== 'records') this.futurePlanner.open = false;
          this.futurePlanner.hidden = this.state.inputMode !== 'records';
          this.futurePlaceholder.hidden = this.state.inputMode === 'records';
          if (this.state.inputMode !== 'records') this.selectRecommendationTarget('today');
          this.renderCalculator();
          this.renderLiveMatches();
          this.track('aa_finder_input_mode_changed', {
            input_mode: this.state.inputMode
          });
        });
      });

      this.capacity.addEventListener('input', () => {
        this.state.capacity = Number(this.capacity.value);
        this.capacityNumber.value = String(this.state.capacity);
        this.setFieldValidity(this.capacityNumber, this.capacityError, true);
        this.validateCalculatorInput();
        this.renderCalculator();
        this.renderLiveMatches();
      });

      this.capacityNumber.addEventListener('input', () => {
        const entered = Number(this.capacityNumber.value);
        const valid = Number.isInteger(entered) && entered >= 1 && entered <= 1000;
        this.setFieldValidity(this.capacityNumber, this.capacityError, valid, this.dataset.capacityRangeError);
        this.validateCalculatorInput();
        if (!valid) return;
        this.state.capacity = entered;
        this.capacity.value = String(Math.min(1000, Math.max(10, Math.round(entered / 10) * 10)));
        this.renderCalculator();
        this.renderLiveMatches();
      });

      this.futurePlanner.addEventListener('toggle', () => {
        if (!this.futurePlanner.open) this.selectRecommendationTarget('today');
        this.renderCalculator();
        this.renderLiveMatches();
        if (this.futurePlanner.open) {
          this.track('aa_finder_future_planner_opened', {
            capacity_band: this.capacityBand()
          });
        }
      });

      this.monthlyGrowth.addEventListener('input', () => {
        const monthly = Math.min(50, Math.max(0, Math.floor(Number(this.monthlyGrowth.value) || 0)));
        this.state.monthlyGrowth = monthly;
        if (!monthly) this.selectRecommendationTarget('today');
        this.renderCalculator();
        this.renderLiveMatches();
      });

      this.monthlyGrowth.addEventListener('change', () => {
        if (!this.state.futurePlanning) return;
        this.track('aa_finder_future_plan_changed', {
          monthly_growth: this.state.monthlyGrowth,
          projected_capacity_band: this.capacityBand()
        });
      });

      this.recordProfiles.forEach((input) => {
        input.addEventListener('change', () => {
          if (!input.checked) return;
          this.state.recordProfile = input.value;
          this.renderCalculator();
          this.track('aa_finder_record_profile_changed', {
            profile: this.state.recordProfile,
            capacity_band: this.capacityBand()
          });
        });
      });

      this.recommendationTargets.forEach((input) => {
        input.addEventListener('change', () => {
          if (!input.checked) return;
          this.selectRecommendationTarget(input.value);
          this.renderCalculator();
          this.renderLiveMatches();
          this.track('aa_finder_recommendation_target_changed', {
            recommendation_target: input.value,
            capacity_band: this.capacityBand()
          });
        });
      });

      this.shelfLength.addEventListener('input', () => {
        this.shelfLengthNumber.value = this.shelfLength.value;
        this.setFieldValidity(this.shelfLengthNumber, this.shelfError, true);
        this.validateCalculatorInput();
        this.renderCalculator();
        this.renderLiveMatches();
      });
      this.shelfLengthNumber.addEventListener('input', () => {
        const minimum = Number(this.shelfLength.min);
        const maximum = Number(this.shelfLength.max);
        const entered = Number(this.shelfLengthNumber.value);
        const valid = Number.isFinite(entered) && entered >= minimum && entered <= maximum;
        const error = this.interpolate(this.dataset.shelfRangeError, {
          min: minimum,
          max: maximum,
          unit: this.state.unit
        });
        this.setFieldValidity(this.shelfLengthNumber, this.shelfError, valid, error);
        this.validateCalculatorInput();
        if (!valid) return;
        this.shelfLength.value = String(entered);
        this.renderCalculator();
        this.renderLiveMatches();
      });

      this.querySelectorAll('[data-unit]').forEach((button) => {
        button.addEventListener('click', () => this.changeUnit(button.dataset.unit));
      });

      this.querySelectorAll('[data-dimension]').forEach((input) => {
        input.addEventListener('input', () => this.renderLiveMatches());
      });

      this.querySelectorAll('input[name^="finder-mobility"]').forEach((input) => {
        input.addEventListener('change', () => {
          this.state.mobility = input.value;
          this.renderLiveMatches();
        });
      });

      this.querySelector('[data-show-results]').addEventListener('click', () => this.renderResults());
      this.querySelector('[data-show-floor-options]').addEventListener('click', () => {
        const previousPlacement = this.state.placement;
        this.state.placement = 'floor';
        this.querySelectorAll('.aa-finder__place[data-placement]').forEach((item) => {
          item.setAttribute('aria-pressed', item.dataset.placement === 'floor' ? 'true' : 'false');
        });
        this.mobilityField.hidden = false;
        this.updateProgressSummary();
        this.track('aa_finder_alternative_selected', {
          alternative: 'floor',
          previous_placement: previousPlacement,
          capacity_band: this.capacityBand(),
          has_dimensions: this.hasDimensions()
        });
        this.renderLiveMatches();
        this.liveSummary.setAttribute('tabindex', '-1');
        this.liveSummary.focus({ preventScroll: true });
      });
      this.querySelector('.aa-finder__form')?.addEventListener('submit', () => {
        this.track('aa_finder_custom_request_submitted', {
          placement: this.state.placement,
          capacity_band: this.capacityBand(),
          has_dimensions: this.hasDimensions(),
          mobility: this.state.mobility
        });
      });

      this.addEventListener('click', (event) => {
        const request = event.target.closest('[data-open-request]');
        if (request) {
          event.preventDefault();
          const requestMatchType = request.closest('[data-match-type]')?.dataset.matchType || 'unknown';
          this.openRequest(request.dataset.productTitle || '', requestMatchType);
        }
        const productLink = event.target.closest('.aa-finder__live-card > a, .aa-finder__model-preview, .aa-finder__model-actions > a');
        if (productLink) {
          const productPath = new URL(productLink.href, window.location.origin).pathname;
          const matchType =
            productLink.dataset.matchType ||
            productLink.closest('[data-match-type]')?.dataset.matchType ||
            'unknown';
          const attribution = {
            source: 'record_storage_finder',
            product_path: productPath,
            placement: this.state.placement,
            capacity_band: this.capacityBand(),
            match_type: matchType,
            mobility: this.state.mobility,
            timestamp: Date.now()
          };
          const shouldDelayNavigation =
            event.button === 0 &&
            !event.metaKey &&
            !event.ctrlKey &&
            !event.shiftKey &&
            !event.altKey &&
            productLink.target !== '_blank';
          this.track('aa_finder_model_click', {
            placement: this.state.placement,
            capacity_band: this.capacityBand(),
            product_path: productPath,
            match_type: matchType,
            mobility: this.state.mobility
          }, shouldDelayNavigation ? productLink.href : '');
          try {
            window.sessionStorage.setItem('aa_finder_attribution', JSON.stringify(attribution));
          } catch (error) {
            void error;
          }
        }
        const collectionLink = event.target.closest('[data-floor-collection-link], [data-capacity-collection-link]');
        if (collectionLink) {
          this.track('aa_finder_collection_click', {
            placement: this.state.placement,
            capacity_band: this.capacityBand(),
            collection_path: new URL(collectionLink.href, window.location.origin).pathname
          });
        }
      });
    }

    setFieldValidity(input, errorElement, valid, message = '') {
      input.setAttribute('aria-invalid', valid ? 'false' : 'true');
      errorElement.hidden = valid;
      errorElement.textContent = valid ? '' : message;
    }

    validateCalculatorInput() {
      const input = this.state.inputMode === 'records' ? this.capacityNumber : this.shelfLengthNumber;
      const value = Number(input.value);
      const valid =
        input.value.trim() !== '' &&
        Number.isFinite(value) &&
        value >= Number(input.min) &&
        value <= Number(input.max) &&
        (this.state.inputMode !== 'records' || Number.isInteger(value));
      this.calculatorContinue.disabled = !valid;
      return valid;
    }

    selectPlacement(button) {
      if (!button || button.disabled) return;
      this.quickResults = false;
      this.state.placement = button.dataset.placement;
      this.querySelectorAll('.aa-finder__place[data-placement]').forEach((item) => {
        item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
      });
      this.mobilityField.hidden = !['floor', 'all'].includes(this.state.placement);
      this.placementContinue.disabled = false;
      this.updateProgressSummary();
      this.renderLiveMatches();
      this.track('aa_finder_placement_selected', {
        placement: this.state.placement,
        capacity_band: this.capacityBand(),
        storage_plan: this.state.storagePlan
      });
    }

    recommendedListeningCount() {
      const target = this.capacityTarget();
      if (target < 60) return 0;
      if (target <= 120) return 20;
      if (target <= 360) return 40;
      return 60;
    }

    maximumListeningCount() {
      return Math.min(60, Math.floor(this.capacityTarget() / 2));
    }

    mainCapacityTarget() {
      const total = this.capacityTarget();
      return this.state.storagePlan === 'two-zone'
        ? Math.max(1, total - this.state.listeningCount)
        : total;
    }

    renderStoragePlan() {
      const target = this.capacityTarget();
      const canUseTwoZone = target >= 60;
      if (!canUseTwoZone && this.state.storagePlan === 'two-zone') this.state.storagePlan = 'single';
      const maximumListening = this.maximumListeningCount();
      this.listeningCounts.forEach((input) => {
        input.disabled = Number(input.value) > maximumListening;
      });
      if (
        this.state.storagePlan === 'two-zone' &&
        (this.state.listeningCount > maximumListening || this.state.listeningCount <= 0)
      ) {
        this.state.listeningCount = this.recommendedListeningCount();
        this.listeningCounts.forEach((input) => {
          input.checked = Number(input.value) === this.state.listeningCount;
        });
      }

      const twoZone = this.state.storagePlan === 'two-zone';
      const profileLabel =
        this.recordProfiles
          .find((input) => input.checked)
          ?.closest('label')
          ?.querySelector('strong')
          ?.textContent.trim() || this.state.recordProfile;
      const density = this.profileDensity();
      const minimumLengthInches = target / density.max * 12;
      const maximumLengthInches = target / density.min * 12;
      const enteredLength = Number(this.shelfLength.value) || 0;
      const suggestedListening = this.recommendedListeningCount();
      const choiceListening = twoZone ? this.state.listeningCount : suggestedListening;
      const choiceMain = Math.max(1, target - choiceListening);
      this.planTitle.textContent = this.interpolate(this.dataset.planQuestionTitle, { target });
      this.planCopy.textContent = this.interpolate(this.dataset.planChoiceCopy, { target });
      this.planTotal.textContent = this.interpolate(this.dataset.planTotalOutput, { target });
      this.planCollectedDetail.textContent =
        this.state.inputMode === 'space'
          ? this.interpolate(this.dataset.planCollectedSpaceDetail, {
              profile: profileLabel,
              length: enteredLength,
              unit: this.state.unit
            })
          : this.interpolate(this.dataset.planCollectedDetail, {
              profile: profileLabel,
              min: this.formatLength(minimumLengthInches),
              max: this.formatLength(maximumLengthInches),
              unit: this.state.unit
            });
      this.planSingleCopy.textContent = this.interpolate(this.dataset.planSingleCopy, { target });
      this.planTwoZoneLabel.textContent = canUseTwoZone
        ? this.dataset.planUseTwoZone
        : this.dataset.planTwoZoneUnavailable;
      this.planTwoZoneCopy.textContent = canUseTwoZone
        ? this.interpolate(this.dataset.planTwoZoneCopy, {
            count: choiceListening,
            main: choiceMain
          })
        : this.dataset.planTwoZoneUnavailableCopy;
      this.planMain.textContent = this.interpolate(
        twoZone ? this.dataset.planMainOutput : this.dataset.planMainTogether,
        { target: this.mainCapacityTarget() }
      );
      this.planListening.textContent = twoZone
        ? this.interpolate(this.dataset.planListeningOutput, { count: this.state.listeningCount })
        : this.dataset.planListeningOptional;
      this.listeningSize.hidden = !twoZone;
      this.listeningPlaceholder.hidden = twoZone;
      this.twoZoneButton.disabled = !canUseTwoZone;
      this.twoZoneButton.setAttribute('aria-pressed', twoZone ? 'true' : 'false');
      this.singleZoneButton.setAttribute('aria-pressed', twoZone ? 'false' : 'true');
      this.placeQuestion.textContent = this.interpolate(
        twoZone ? this.dataset.placeMainQuestion : this.dataset.placeQuestion,
        { target: this.mainCapacityTarget() }
      );
      this.placeHint.textContent = this.interpolate(
        twoZone ? this.dataset.placeMainHint : this.dataset.placeHintText,
        {
          target: this.mainCapacityTarget(),
          listening: this.state.listeningCount
        }
      );
      this.querySelectorAll('.aa-finder__place[data-placement]').forEach((button) => {
        const label = button.querySelector('[data-label-single]');
        const detail = button.querySelector('[data-detail-single]');
        if (!label || !detail) return;
        label.textContent = this.interpolate(
          twoZone ? label.dataset.labelTwoZone : label.dataset.labelSingle,
          { target: this.mainCapacityTarget() }
        );
        detail.textContent = this.interpolate(
          twoZone ? detail.dataset.detailTwoZone : detail.dataset.detailSingle,
          { target: this.mainCapacityTarget() }
        );
      });
      if (this.mainResultsTitle) {
        this.mainResultsTitle.textContent = this.interpolate(this.dataset.mainResultsTitle, {
          target: this.mainCapacityTarget()
        });
      }
      this.renderPlacementGuidance();
    }

    placementCapacityAssessment(placement) {
      const target = this.mainCapacityTarget();
      const candidates = this.models
        .filter((model) => {
          const placements = model.dataset.placement.split(',').map((item) => item.trim());
          return (
            model.dataset.fitType !== 'custom' &&
            (placement === 'all' || placements.includes('all') || placements.includes(placement)) &&
            target >= (Number(model.dataset.capacityMin) || 0) &&
            Number(model.dataset.capacityMax) > 0
          );
        })
        .map((model) => ({
          model,
          units: Math.max(1, Math.ceil(target / Number(model.dataset.capacityMax)))
        }))
        .sort(
          (a, b) =>
            a.units - b.units ||
            Number(b.model.dataset.capacityMax) - Number(a.model.dataset.capacityMax) ||
            Number(b.model.dataset.priority) - Number(a.model.dataset.priority)
        );
      return {
        units: candidates[0]?.units || 0,
        candidates
      };
    }

    renderPlacementGuidance() {
      const assessments = {
        shelf: this.placementCapacityAssessment('shelf'),
        console: this.placementCapacityAssessment('console'),
        floor: this.placementCapacityAssessment('floor'),
        all: this.placementCapacityAssessment('all')
      };
      const floorRecommended =
        assessments.floor.units > 0 &&
        assessments.floor.units < Math.min(
          assessments.shelf.units || Number.POSITIVE_INFINITY,
          assessments.console.units || Number.POSITIVE_INFINITY
        );
      this.querySelectorAll('.aa-finder__place[data-placement]').forEach((button) => {
        const placement = button.dataset.placement;
        const assessment = assessments[placement];
        const recommended = placement !== 'all' && floorRecommended && placement === 'floor';
        let status = this.dataset.placementNoMatch;
        if (assessment.units === 1) status = this.dataset.placementFitsOne;
        if (assessment.units > 1) {
          status = this.interpolate(this.dataset.placementRequiresUnits, {
            count: assessment.units
          });
        }
        if (recommended) status = this.dataset.placementRecommended;
        if (placement === 'all') status = this.dataset.placementCompare;
        button.classList.toggle('is-recommended', recommended);
        button.querySelector('[data-placement-status]').textContent = status;
      });
    }

    selectRecommendationTarget(target) {
      const useFuture =
        target === 'future' &&
        this.state.inputMode === 'records' &&
        this.futurePlanner.open &&
        this.state.monthlyGrowth > 0;
      this.state.futurePlanning = useFuture;
      this.recommendationTargets.forEach((input) => {
        input.checked = input.value === (useFuture ? 'future' : 'today');
      });
    }

    updateProgress(number = this.currentStep) {
      this.currentStep = number;
      this.progress.forEach((item) => {
        const itemNumber = Number(item.dataset.progress);
        const isCurrent = itemNumber === number;
        item.classList.toggle('is-current', isCurrent);
        item.classList.toggle('is-complete', itemNumber < number);
        if (isCurrent) item.setAttribute('aria-current', 'step');
        else item.removeAttribute('aria-current');
      });
      const currentLabel =
        this.progress.find((item) => Number(item.dataset.progress) === number)?.textContent.trim() || '';
      this.progressCurrent.textContent = this.interpolate(this.dataset.progressStepTemplate, {
        current: number,
        total: this.progress.length,
        label: currentLabel
      });
      this.updateProgressSummary();
    }

    updateProgressSummary() {
      const selectedProfile =
        this.recordProfiles
          .find((input) => input.checked)
          ?.closest('label')
          ?.querySelector('strong')
          ?.textContent.trim() || this.state.recordProfile;
      const selectedPlanButton =
        this.state.storagePlan === 'two-zone' ? this.twoZoneButton : this.singleZoneButton;
      const selectedPlan =
        selectedPlanButton?.querySelector('strong')?.textContent.trim() || this.state.storagePlan;
      const selectedPlacementButton = this.querySelector(
        `.aa-finder__place[data-placement="${this.state.placement}"]`
      );
      const selectedPlacement =
        selectedPlacementButton?.querySelector('strong')?.textContent.trim() || this.state.placement;
      const showSummary = Boolean(this.state.placement) && this.currentStep > 2;
      this.progressSummary.hidden = !showSummary;
      if (!showSummary) return;
      this.progressSummaryText.textContent = this.interpolate(this.dataset.progressSummaryTemplate, {
        capacity: this.capacityTarget(),
        profile: selectedProfile,
        plan: selectedPlan,
        placement: selectedPlacement
      });
    }

    showStep(number) {
      this.steps.forEach((step) => {
        const active = Number(step.dataset.step) === number;
        step.hidden = !active;
        step.classList.toggle('is-active', active);
      });
      this.updateProgress(number);
      this.workspace.classList.toggle('is-results', number === 4);
      this.livePanel.hidden = number !== 3;
      const activeStep = this.querySelector(`[data-step="${number}"]`);
      const heading = activeStep.querySelector('legend, h2');
      if (heading) heading.setAttribute('tabindex', '-1');
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          const stickyHeight = this.progressShell.getBoundingClientRect().height;
          const activeTop = window.scrollY + activeStep.getBoundingClientRect().top;
          window.scrollTo({ top: Math.max(0, activeTop - stickyHeight - 16), behavior: 'auto' });
          if (heading) heading.focus({ preventScroll: true });
        });
      });
    }

    changeUnit(nextUnit) {
      if (nextUnit === this.state.unit) return;
      const factor = nextUnit === 'cm' ? 2.54 : 1 / 2.54;
      this.querySelectorAll('[data-dimension]').forEach((input) => {
        if (input.value) input.value = (Number(input.value) * factor).toFixed(1);
      });
      if (this.shelfLength.value) {
        const converted = Number(this.shelfLength.value) * factor;
        const nextValue =
          nextUnit === 'cm'
            ? converted.toFixed(1)
            : String(Math.round(converted * 2) / 2);
        const minimum = nextUnit === 'cm' ? '12.7' : '5';
        const maximum = nextUnit === 'cm' ? '304.8' : '120';
        const step = nextUnit === 'cm' ? '0.1' : '0.5';
        [this.shelfLength, this.shelfLengthNumber].forEach((input) => {
          input.min = minimum;
          input.max = maximum;
          input.step = step;
          input.value = nextValue;
        });
      }
      this.state.unit = nextUnit;
      this.querySelectorAll('[data-unit]').forEach((button) => {
        const active = button.dataset.unit === nextUnit;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      this.querySelectorAll('[data-unit-label]').forEach((label) => {
        label.textContent = nextUnit;
      });
      this.renderCalculator();
      this.renderLiveMatches();
    }

    profileDensity() {
      const profiles = {
        standard: { min: 70, max: 80 },
        mixed: { min: 60, max: 70 },
        gatefold: { min: 45, max: 55 }
      };
      return profiles[this.state.recordProfile] || profiles.mixed;
    }

    formatLength(inches) {
      const converted = this.state.unit === 'cm' ? inches * 2.54 : inches;
      return String(Math.ceil(converted));
    }

    currentPlanningTarget() {
      return this.state.capacity;
    }

    futureCapacity() {
      return this.state.capacity + this.state.monthlyGrowth * 12;
    }

    renderFuturePlanner(density) {
      const active =
        this.state.inputMode === 'records' &&
        this.futurePlanner.open &&
        this.state.monthlyGrowth > 0;
      this.futureEmpty.hidden = active;
      this.futureResult.hidden = !active;
      if (!active) return;

      const future = this.futureCapacity();
      const minimumLengthInches = future / density.max * 12;
      const maximumLengthInches = future / density.min * 12;
      this.futureCollectionResult.textContent = this.interpolate(this.dataset.futureCollectionResult, {
        current: this.state.capacity,
        future
      });
      this.futureLengthResult.textContent = this.interpolate(this.dataset.futureLengthResult, {
        min: this.formatLength(minimumLengthInches),
        max: this.formatLength(maximumLengthInches),
        unit: this.state.unit
      });
      this.currentTargetLabel.textContent = this.interpolate(this.dataset.currentTargetOption, {
        target: this.state.capacity
      });
      this.futureTargetLabel.textContent = this.interpolate(this.dataset.futureTargetOption, {
        target: future
      });
    }

    renderCalculator() {
      const density = this.profileDensity();
      const target = this.currentPlanningTarget();
      const enteredLength = Number(this.shelfLength.value) || 0;
      const spaceMode = this.state.inputMode === 'space';
      this.shelfLengthResult.hidden = spaceMode;
      this.shelfCapacityResult.hidden = !spaceMode;
      this.calculatorDisclaimer.hidden = spaceMode;
      this.capacityNote.hidden = !spaceMode || !enteredLength;
      this.resultLabel.textContent = spaceMode
        ? this.dataset.calculatorCapacityLabel
        : this.dataset.calculatorLengthLabel;

      if (!spaceMode) {
        const minimumLengthInches = target / density.max * 12;
        const maximumLengthInches = target / density.min * 12;
        this.shelfLengthResult.textContent = this.interpolate(this.dataset.calculatorLengthResult, {
          min: this.formatLength(minimumLengthInches),
          max: this.formatLength(maximumLengthInches),
          unit: this.state.unit,
          target,
          record_label: target === 1 ? this.dataset.recordSingular : this.dataset.records
        });
      } else if (!enteredLength) {
        this.shelfCapacityResult.textContent = this.dataset.calculatorCapacityEmpty;
      } else {
        const lengthInInches = this.state.unit === 'cm' ? enteredLength / 2.54 : enteredLength;
        const lengthInFeet = Math.round(lengthInInches * 1000) / 1000 / 12;
        const minimumCapacity = Math.max(1, Math.floor(lengthInFeet * density.min));
        const maximumCapacity = Math.max(1, Math.floor(lengthInFeet * density.max));
        this.state.capacity = minimumCapacity;
        this.capacityNumber.value = String(minimumCapacity);
        this.capacity.value = String(Math.min(1000, Math.max(10, Math.round(minimumCapacity / 10) * 10)));
        this.shelfCapacityResult.textContent =
          minimumCapacity > 1000
            ? this.dataset.calculatorCapacityOver
            : this.interpolate(this.dataset.calculatorCapacityResult, {
                min: minimumCapacity,
                max: maximumCapacity
              });
        this.capacityNote.textContent = this.interpolate(this.dataset.calculatorCapacityNote, {
          target: minimumCapacity
        });
      }

      const needsSpace = spaceMode && !enteredLength;
      this.querySelectorAll('.aa-finder__place[data-placement]').forEach((button) => {
        button.disabled = needsSpace;
      });
      this.placementContinue.disabled = needsSpace || !this.state.placement;
      this.futurePlanner.hidden = spaceMode;
      this.futurePlaceholder.hidden = !spaceMode;
      this.renderFuturePlanner(density);
      this.renderStoragePlan();

      const collectionTarget = this.mainCapacityTarget();
      if (collectionTarget >= 210 && this.dataset.collectionLargeUrl) {
        this.capacityCollectionLink.href = this.dataset.collectionLargeUrl;
        this.capacityCollectionLink.textContent = this.dataset.collectionLargeLabel;
      } else if (collectionTarget >= 130 && this.dataset.collection200Url) {
        this.capacityCollectionLink.href = this.dataset.collection200Url;
        this.capacityCollectionLink.textContent = this.dataset.collection200Label;
      } else {
        this.capacityCollectionLink.href = this.dataset.collectionAllUrl;
        this.capacityCollectionLink.textContent = this.dataset.collectionAllLabel;
      }
    }

    dimensionsInInches() {
      const values = {};
      this.querySelectorAll('[data-dimension]').forEach((input) => {
        const value = Number(input.value) || 0;
        values[input.dataset.dimension] = this.state.unit === 'cm' ? value / 2.54 : value;
      });
      return values;
    }

    hasDimensions() {
      const dimensions = this.dimensionsInInches();
      return Boolean(dimensions.width || dimensions.depth || dimensions.height);
    }

    capacityTarget() {
      return this.state.futurePlanning ? this.futureCapacity() : this.currentPlanningTarget();
    }

    capacityBand() {
      const capacity = this.capacityTarget();
      if (capacity <= 60) return '10-60';
      if (capacity <= 120) return '70-120';
      if (capacity <= 200) return '130-200';
      if (capacity <= 400) return '210-400';
      return '410+';
    }

    interpolate(text, values) {
      return Object.entries(values).reduce(
        (result, [key, value]) => result.replaceAll(`[${key}]`, String(value)),
        text
      );
    }

    track(eventName, parameters = {}, navigationUrl = '') {
      const shopifyEventName = `atelier_article:${eventName}`;
      const publish = window.Shopify?.analytics?.publish;
      if (typeof publish === 'function') {
        Promise.resolve(publish(shopifyEventName, parameters)).catch(() => {});
      }
      if (navigationUrl && typeof window.aaQueueGa4EventForNextPage === 'function') {
        window.aaQueueGa4EventForNextPage(eventName, parameters);
      } else {
        if (typeof window.aaSendGa4Event === 'function') {
          window.aaSendGa4Event(eventName, parameters);
        }
      }
    }

    renderAdvice(matchCount) {
      if (!this.state.placement) {
        this.advice.hidden = true;
        return;
      }
      const target = this.mainCapacityTarget();
      const dimensions = this.dimensionsInInches();
      const placement = this.state.placement;
      const titleKey =
        placement === 'shelf'
          ? 'adviceTitleShelf'
          : placement === 'console'
            ? 'adviceTitleConsole'
            : placement === 'floor'
              ? 'adviceTitleFloor'
              : 'adviceTitleAll';
      let primaryKey = 'adviceAll';
      if (placement === 'shelf') primaryKey = target <= 60 ? 'adviceShelfSmall' : 'adviceShelfLarge';
      if (placement === 'console') {
        primaryKey =
          target <= 60
            ? 'adviceConsoleSmall'
            : target <= 120
              ? 'adviceConsoleMedium'
              : 'adviceConsoleLarge';
      }
      if (placement === 'floor') primaryKey = target <= 120 ? 'adviceFloorSmall' : 'adviceFloorLarge';

      const replacements = {
        capacity: this.state.capacity,
        target,
        width: dimensions.width ? dimensions.width.toFixed(1).replace('.0', '') : '',
        depth: dimensions.depth ? dimensions.depth.toFixed(1).replace('.0', '') : '',
        height: dimensions.height ? dimensions.height.toFixed(1).replace('.0', '') : ''
      };
      this.querySelector('[data-advice-title]').textContent = this.interpolate(this.dataset[titleKey], replacements);
      this.querySelector('[data-advice-primary]').textContent = this.interpolate(this.dataset[primaryKey], replacements);

      const secondary = [];
      if (dimensions.width && dimensions.width < 8) secondary.push(this.dataset.adviceNarrow);
      if (dimensions.depth && dimensions.depth < 14) secondary.push(this.dataset.adviceShallow);
      if (dimensions.height && dimensions.height < 20) secondary.push(this.dataset.adviceLow);
      if (placement === 'floor' && this.state.mobility === 'mobile') secondary.push(this.dataset.adviceMobile);
      if (placement === 'floor' && this.state.mobility === 'any') secondary.push(this.dataset.adviceOccasional);
      if (placement === 'floor' && this.state.mobility === 'fixed') secondary.push(this.dataset.adviceFixed);
      const secondaryNode = this.querySelector('[data-advice-secondary]');
      secondaryNode.hidden = secondary.length === 0;
      secondaryNode.textContent = secondary.length
        ? this.interpolate(secondary.join(' '), replacements)
        : '';

      const growthNode = this.querySelector('[data-advice-growth]');
      growthNode.hidden = !this.state.growth;
      growthNode.textContent = this.state.growth
        ? this.interpolate(this.dataset.adviceGrowth, replacements)
        : '';
      this.advice.hidden = false;

      const signature = [
        placement,
        this.capacityBand(),
        Boolean(dimensions.width || dimensions.depth || dimensions.height),
        this.state.mobility,
        matchCount
      ].join('|');
      if (signature !== this.lastTrackedAdvice) {
        this.lastTrackedAdvice = signature;
        this.track('aa_finder_recommendation_shown', {
          placement,
          capacity_band: this.capacityBand(),
          has_dimensions: Boolean(dimensions.width || dimensions.depth || dimensions.height),
          mobility: this.state.mobility,
          match_count: matchCount
        });
        try {
          window.sessionStorage.setItem('aa_finder_recommendation_seen', 'true');
        } catch (error) {
          void error;
        }
      }
    }

    placementMatches(model, placement = this.state.placement) {
      const placements = model.dataset.placement.split(',').map((item) => item.trim());
      return placement === 'all' || placements.includes('all') || placements.includes(placement);
    }

    mobilityMatches(model, mobility = this.state.mobility) {
      if (mobility === 'any') return true;
      const mobile = model.dataset.mobile === 'true';
      return mobility === 'mobile' ? mobile : !mobile;
    }

    modelConfigurations(model) {
      if (!model.dataset.configurations) return [];
      try {
        const configurations = JSON.parse(model.dataset.configurations);
        if (!Array.isArray(configurations)) return [];
        return configurations
          .map((configuration) => ({
            capacity: Number(configuration.capacity) || 0,
            width: Number(configuration.width_in) || 0,
            depth: Number(configuration.loaded_depth_in) || 0,
            height: Number(configuration.loaded_height_in) || 0
          }))
          .filter((configuration) => configuration.capacity > 0);
      } catch (error) {
        return [];
      }
    }

    configuredSizeAssessment(model, dimensions, target) {
      const configurations = this.modelConfigurations(model);
      const capacityMax = Number(model.dataset.capacityMax) || 0;
      if (!configurations.length || target > capacityMax) return null;

      const candidates = configurations.filter((configuration) => configuration.capacity >= target);
      if (!candidates.length) return null;

      const keys = ['width', 'depth', 'height'];
      const constrainedKeys = keys.filter((key) => dimensions[key]);
      const unknownKeys = constrainedKeys.filter((key) =>
        candidates.every((configuration) => !configuration[key])
      );
      if (unknownKeys.length) {
        return { exceeds: false, configurable: false, exceedingKeys: [], unknownKeys };
      }

      const assessments = candidates.map((configuration) => {
        const exceedingKeys = constrainedKeys.filter(
          (key) => configuration[key] && configuration[key] > dimensions[key]
        );
        const excess = exceedingKeys.reduce(
          (sum, key) => sum + (configuration[key] - dimensions[key]) / dimensions[key],
          0
        );
        return { configuration, exceedingKeys, excess };
      });
      assessments.sort(
        (a, b) =>
          a.exceedingKeys.length - b.exceedingKeys.length ||
          a.excess - b.excess ||
          a.configuration.capacity - b.configuration.capacity
      );
      const best = assessments[0];
      return {
        exceeds: best.exceedingKeys.length > 0,
        configurable: configurations.length > 1,
        exceedingKeys: best.exceedingKeys,
        unknownKeys: []
      };
    }

    sizeAssessment(model, dimensions, target = this.mainCapacityTarget()) {
      const configuredAssessment = this.configuredSizeAssessment(model, dimensions, target);
      if (configuredAssessment) return configuredAssessment;

      const keys = ['width', 'depth', 'height'];
      let exceeds = false;
      let configurable = false;
      const exceedingKeys = [];
      const unknownKeys = [];
      keys.forEach((key) => {
        const available = dimensions[key];
        if (!available) return;
        const minimum = Number(model.dataset[`${key}Min`]) || Number(model.dataset[key]) || 0;
        const maximum = Number(model.dataset[`${key}Max`]) || minimum;
        if (!minimum) {
          unknownKeys.push(key);
          return;
        }
        if (minimum && minimum > available) {
          exceeds = true;
          exceedingKeys.push(key);
        }
        if (minimum && maximum > minimum && available >= minimum && available < maximum) configurable = true;
      });
      return { exceeds, configurable, exceedingKeys, unknownKeys };
    }

    classify(model, dimensions, options = {}) {
      const target = options.target || this.mainCapacityTarget();
      const placement = options.placement || this.state.placement;
      const mobility = options.mobility || this.state.mobility;
      if (!this.placementMatches(model, placement) || !this.mobilityMatches(model, mobility)) return null;
      const capacityMin = Number(model.dataset.capacityMin);
      const capacityMax = Number(model.dataset.capacityMax);
      const fitType = model.dataset.fitType;
      const customAvailable = model.dataset.customAvailable === 'true';
      const customDimensions = model.dataset.customDimensions
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);
      const size = this.sizeAssessment(model, dimensions, target);
      if (size.unknownKeys.length) return null;
      if (capacityMin && target < capacityMin) return null;
      const needsCapacityChange = target > capacityMax;
      const requiredUnits = capacityMax ? Math.ceil(target / capacityMax) : 0;
      const hasDimensions = Boolean(dimensions.width || dimensions.depth || dimensions.height);
      if (needsCapacityChange && requiredUnits > 1 && requiredUnits <= 4 && !hasDimensions && fitType !== 'custom') {
        return 'multi';
      }
      if (needsCapacityChange || size.exceeds) {
        if (!customAvailable) return null;
        if (size.exceedingKeys.some((key) => !customDimensions.includes(key))) return null;
        const availableWidth = dimensions.width;
        const customWidthMin = Number(model.dataset.customWidthMin) || 0;
        if (size.exceedingKeys.includes('width') && customWidthMin && availableWidth < customWidthMin) return null;
        if (needsCapacityChange && target > capacityMax * 1.5) return null;
        return 'custom';
      }
      if (fitType === 'custom') return customAvailable ? 'custom' : null;
      if (fitType === 'configure' || size.configurable) return 'configure';
      return 'exact';
    }

    matchingGroups(options = {}) {
      const dimensions = options.dimensions || this.dimensionsInInches();
      const target = options.target || this.mainCapacityTarget();
      const placement = options.placement || this.state.placement;
      const mobility = options.mobility || this.state.mobility;
      const groups = { exact: [], configure: [], multi: [], custom: [] };
      this.models.forEach((model) => {
        const classification = this.classify(model, dimensions, { target, placement, mobility });
        if (!classification) return;
        groups[classification].push(model);
      });
      Object.entries(groups).forEach(([classification, models]) => {
        models.sort((a, b) => {
          if (classification === 'multi') {
            const unitsDifference =
              Math.ceil(target / Number(a.dataset.capacityMax)) -
              Math.ceil(target / Number(b.dataset.capacityMax));
            if (unitsDifference) return unitsDifference;
          }
          return Number(b.dataset.priority) - Number(a.dataset.priority);
        });
      });
      return groups;
    }

    matchingGroupsForPlacement(placement) {
      return this.matchingGroups({ placement });
    }

    createLiveCard(model, classification) {
      const card = document.createElement('article');
      card.className = 'aa-finder__live-card';
      card.dataset.matchType = classification;
      const link = document.createElement('a');
      link.href = model.querySelector('.aa-finder__model-actions a').getAttribute('href');
      link.dataset.matchType = classification;
      const media = model.querySelector('.aa-finder__model-media').cloneNode(true);
      const body = model.querySelector('.aa-finder__model-body').cloneNode(true);
      body.querySelector('[data-model-badge]').textContent = this.dataset[
        classification === 'exact'
          ? 'fitLabel'
          : classification === 'configure'
            ? 'configureLabel'
            : classification === 'multi'
              ? 'multiLabel'
              : 'customLabel'
      ];
      const reason = document.createElement('span');
      reason.className = 'aa-finder__live-reason';
      reason.textContent =
        classification === 'multi'
          ? this.interpolate(this.dataset.liveMultiReason, {
              count: Math.ceil(this.mainCapacityTarget() / Number(model.dataset.capacityMax)),
              target: this.mainCapacityTarget()
            })
          : this.dataset[
              classification === 'exact'
                ? 'liveExactReason'
                : classification === 'configure'
                  ? 'liveConfigureReason'
                  : 'liveCustomReason'
            ];
      body.appendChild(reason);
      link.append(media, body);
      card.appendChild(link);
      return card;
    }

    listeningModels() {
      const target = this.state.listeningCount;
      return this.models
        .filter((model) => {
          const placements = model.dataset.placement.split(',').map((item) => item.trim());
          const capacityMin = Number(model.dataset.capacityMin) || 0;
          const capacityMax = Number(model.dataset.capacityMax) || 0;
          return (
            placements.some((placement) => ['shelf', 'console', 'all'].includes(placement)) &&
            target >= capacityMin &&
            target <= capacityMax &&
            model.dataset.fitType !== 'custom'
          );
        })
        .sort((a, b) => {
          const aArea = (Number(a.dataset.widthMin) || 100) * (Number(a.dataset.depthMin) || 100);
          const bArea = (Number(b.dataset.widthMin) || 100) * (Number(b.dataset.depthMin) || 100);
          return aArea - bArea || Number(b.dataset.priority) - Number(a.dataset.priority);
        })
        .slice(0, 3)
        .map((model) => ({
          model,
          classification: model.dataset.fitType === 'configure' ? 'configure' : 'exact'
        }));
    }

    renderListeningRecommendations() {
      const active = this.state.storagePlan === 'two-zone';
      const recommendations = active ? this.listeningModels() : [];
      const summary = this.interpolate(this.dataset.listeningSummary, {
        count: this.state.listeningCount
      });
      const createCards = () =>
        recommendations.map(({ model, classification }) => {
          const card = this.createLiveCard(model, classification);
          card.querySelector('.aa-finder__live-reason').textContent =
            this.interpolate(this.dataset.listeningReason, { count: this.state.listeningCount });
          return card;
        });

      const liveSection = this.querySelector('[data-live-listening]');
      liveSection.hidden = recommendations.length === 0;
      this.querySelector('[data-live-listening-summary]').textContent = summary;
      this.querySelector('[data-live-listening-list]').replaceChildren(...createCards());

      const resultsSection = this.querySelector('[data-listening-results]');
      resultsSection.hidden = recommendations.length === 0;
      this.querySelector('[data-listening-summary]').textContent = summary;
      this.querySelector('[data-listening-list]').replaceChildren(...createCards());
    }

    matchSummary(groups) {
      const total = Object.values(groups).reduce((sum, models) => sum + models.length, 0);
      if (!total) return this.dataset.noResults;
      const models = total === 1 ? this.dataset.modelSingular : this.dataset.modelPlural;
      const readyMadeCount = groups.exact.length + groups.configure.length + groups.multi.length;
      if (readyMadeCount === 0 && groups.custom.length > 0) {
        return this.interpolate(
          this.state.futurePlanning ? this.dataset.futureCustomOnlySummary : this.dataset.customOnlySummary,
          {
            count: groups.custom.length,
            models: groups.custom.length === 1 ? this.dataset.modelSingular : this.dataset.modelPlural,
            target: this.mainCapacityTarget()
          }
        );
      }
      if (readyMadeCount > 0 && groups.custom.length > 0) {
        return this.interpolate(
          this.state.futurePlanning ? this.dataset.futureMixedMatchSummary : this.dataset.mixedMatchSummary,
          {
            ready: readyMadeCount,
            custom: groups.custom.length,
            target: this.mainCapacityTarget()
          }
        );
      }
      if (this.state.futurePlanning) {
        return this.interpolate(this.dataset.futureLiveSummary, {
          count: readyMadeCount,
          models: readyMadeCount === 1 ? this.dataset.modelSingular : this.dataset.modelPlural,
          target: this.mainCapacityTarget()
        });
      }
      return `${readyMadeCount} ${readyMadeCount === 1 ? this.dataset.modelSingular : this.dataset.modelPlural} ${this.dataset.matchedDetail}`;
    }

    renderLiveMatches() {
      this.updateProgressSummary();
      if (!this.state.placement) return;
      const groups = this.matchingGroups();
      const total = Object.values(groups).reduce((sum, models) => sum + models.length, 0);
      this.liveSummary.textContent = this.matchSummary(groups);
      this.liveGroups.hidden = total === 0;
      this.liveEmpty.hidden = total !== 0;
      Object.entries(groups).forEach(([name, models]) => {
        const section = this.querySelector(`[data-live-group="${name}"]`);
        const list = this.querySelector(`[data-live-list="${name}"]`);
        list.replaceChildren(...models.map((model) => this.createLiveCard(model, name)));
        section.hidden = models.length === 0;
      });
      this.renderFloorAlternative(total);
      if (total === 0) this.renderEmptySummary();
      this.renderAdvice(total);
      this.renderListeningRecommendations();
    }

    renderFloorAlternative(currentMatchCount) {
      const container = this.querySelector('[data-floor-alternative]');
      const eligiblePlacement = ['shelf', 'console'].includes(this.state.placement);
      if (currentMatchCount > 0 || !eligiblePlacement) {
        container.hidden = true;
        return;
      }
      const floorGroups = this.matchingGroupsForPlacement('floor');
      const floorCount = Object.values(floorGroups).reduce((sum, models) => sum + models.length, 0);
      if (floorCount === 0) {
        container.hidden = true;
        return;
      }
      const replacements = { count: floorCount, target: this.mainCapacityTarget() };
      this.querySelector('[data-floor-alternative-copy]').textContent =
        this.interpolate(this.dataset.alternativeFloorCopy, replacements);
      this.querySelector('[data-show-floor-options]').textContent =
        this.interpolate(this.dataset.alternativeFloorButton, replacements);
      const collectionLink = this.querySelector('[data-floor-collection-link]');
      if (this.mainCapacityTarget() >= 210) {
        collectionLink.href = this.dataset.collectionLargeUrl;
        collectionLink.textContent = this.dataset.collectionLargeLabel;
      } else if (this.mainCapacityTarget() >= 130) {
        collectionLink.href = this.dataset.collection200Url;
        collectionLink.textContent = this.dataset.collection200Label;
      } else {
        collectionLink.href = this.dataset.collectionAllUrl;
        collectionLink.textContent = this.dataset.collectionAllLabel;
      }
      container.hidden = false;
    }

    renderEmptySummary() {
      const selectedPlacement = this.querySelector(`.aa-finder__place[data-placement="${this.state.placement}"]`);
      const placementLabel = selectedPlacement?.querySelector('strong')?.textContent.trim() || this.state.placement;
      const dimensions = [...this.querySelectorAll('[data-dimension]')]
        .filter((input) => input.value)
        .map((input) => {
          const label = input.closest('label')?.querySelector(':scope > span:first-child')?.textContent.trim();
          return `${label || input.dataset.dimension}: ${input.value} ${this.state.unit}`;
        });
      const target = this.mainCapacityTarget();
      this.querySelector('[data-empty-capacity]').textContent =
        this.state.futurePlanning
          ? this.interpolate(this.dataset.futureCollectionResult, {
              current: this.state.capacity,
              future: target
            })
          : target === this.state.capacity
          ? `${this.state.capacity} ${this.dataset.records}`
          : `${this.state.capacity} ${this.dataset.records} (${target} ${this.dataset.emptyGrowth})`;
      this.querySelector('[data-empty-placement]').textContent = placementLabel;
      this.querySelector('[data-empty-dimensions]').textContent =
        dimensions.length ? dimensions.join(' · ') : this.dataset.requestNotProvided;
    }

    renderResults() {
      const dimensions = this.dimensionsInInches();
      const groups = this.matchingGroups();
      const fallbackList = this.querySelector('[data-result-list="fallback"]');
      fallbackList.innerHTML = '';

      Object.entries(groups).forEach(([name, models]) => {
        const list = this.querySelector(`[data-result-list="${name}"]`);
        list.innerHTML = '';
        models
          .slice(0, 4)
          .forEach((model) => {
            model.dataset.matchType = name;
            model.querySelector('[data-model-badge]').textContent = this.dataset[
              name === 'exact'
                ? 'fitLabel'
                : name === 'configure'
                  ? 'configureLabel'
                  : name === 'multi'
                    ? 'multiLabel'
                    : 'customLabel'
            ];
            list.appendChild(model);
          });
        this.querySelector(`[data-result-group="${name}"]`).hidden = models.length === 0;
      });

      const total = Object.values(groups).reduce((sum, models) => sum + models.length, 0);
      let fallback = [];
      if (total === 0) {
        const target = this.mainCapacityTarget();
        fallback = this.models
          .filter((model) => {
            if (!this.placementMatches(model) || !this.mobilityMatches(model)) return false;
            const size = this.sizeAssessment(model, dimensions);
            if (size.exceeds || size.unknownKeys.length) return false;
            return Number(model.dataset.capacityMax) >= target * 0.6;
          })
          .sort((a, b) => {
            const capacityDifference =
              Math.abs(target - Number(a.dataset.capacityMax)) -
              Math.abs(target - Number(b.dataset.capacityMax));
            return capacityDifference || Number(b.dataset.priority) - Number(a.dataset.priority);
          })
          .slice(0, 1);
        fallback.forEach((model) => {
          model.dataset.matchType = 'closest';
          model.querySelector('[data-model-badge]').textContent = this.dataset.closestLabel;
          fallbackList.appendChild(model);
        });
      }
      this.querySelector('[data-result-group="fallback"]').hidden = fallback.length === 0;
      this.querySelector('[data-result-summary]').textContent = total
        ? this.matchSummary(groups)
        : fallback.length
          ? this.dataset.closestSummary
          : this.dataset.noResults;
      this.querySelector('[data-empty]').hidden = total !== 0;
      this.renderListeningRecommendations();
      const resultsSignature = [
        this.state.placement,
        this.capacityBand(),
        this.hasDimensions(),
        this.state.mobility,
        total,
        fallback.length
      ].join('|');
      if (resultsSignature !== this.lastTrackedResults) {
        this.lastTrackedResults = resultsSignature;
        this.track('aa_finder_results_viewed', {
          placement: this.state.placement,
          capacity_band: this.capacityBand(),
          has_dimensions: this.hasDimensions(),
          mobility: this.state.mobility,
          future_planning: this.state.futurePlanning,
          monthly_growth: this.state.futurePlanning ? this.state.monthlyGrowth : 0,
          exact_count: groups.exact.length,
          configure_count: groups.configure.length,
          multi_count: groups.multi.length,
          custom_count: groups.custom.length,
          fallback_count: fallback.length
        });
      }
      this.showStep(4);
    }

    openRequest(productTitle, matchType = 'unknown') {
      const panel = this.querySelector('[data-request-panel]');
      const dimensions = [...this.querySelectorAll('[data-dimension]')]
        .filter((input) => input.value)
        .map((input) => `${input.dataset.dimension}: ${input.value} ${this.state.unit}`)
        .join(', ');
      const summary = [
        `${this.dataset.requestPlacement}: ${this.state.placement || this.dataset.requestNotProvided}`,
        `${this.dataset.requestCollection}: ${this.state.capacity} ${this.dataset.records}${this.state.growth ? ` ${this.dataset.requestGrowth}` : ''}`,
        this.state.futurePlanning
          ? `${this.dataset.requestFuture}: ${this.interpolate(this.dataset.futureRequestResult, {
              future: this.futureCapacity(),
              monthly: this.state.monthlyGrowth
            })}`
          : '',
        `${this.dataset.requestProfile}: ${this.recordProfiles.find((input) => input.checked)?.closest('label')?.querySelector('strong')?.textContent.trim() || this.state.recordProfile}`,
        `${this.dataset.requestStoragePlan}: ${
          this.state.storagePlan === 'two-zone'
            ? this.interpolate(this.dataset.requestStoragePlanTwoZone, { count: this.state.listeningCount })
            : this.dataset.requestStoragePlanSingle
        }`,
        this.state.inputMode === 'space'
          ? `${this.dataset.requestShelfLength}: ${this.shelfLength.value} ${this.state.unit}`
          : '',
        dimensions ? `${this.dataset.requestDimensions}: ${dimensions}` : `${this.dataset.requestDimensions}: ${this.dataset.requestNotProvided}`,
        `${this.dataset.requestMobility}: ${this.state.mobility}`,
        productTitle ? `${this.dataset.requestModel}: ${productTitle}` : ''
      ].filter(Boolean).join(' | ');
      panel.hidden = false;
      this.track('aa_finder_custom_request_opened', {
        placement: this.state.placement,
        capacity_band: this.capacityBand(),
        product_title: productTitle || 'not selected',
        match_type: matchType,
        mobility: this.state.mobility
      });
      panel.querySelector('[data-request-summary]').value = summary;
      const message = panel.querySelector('[data-request-message]');
      if (!message.value && productTitle) message.value = this.dataset.requestMessageTemplate.replace('[model]', productTitle);
      const heading = panel.querySelector('h2');
      if (heading) heading.setAttribute('tabindex', '-1');
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          const headingTop = window.scrollY + heading.getBoundingClientRect().top;
          window.scrollTo({ top: Math.max(0, headingTop - 96), behavior: 'auto' });
          heading?.focus({ preventScroll: true });
        });
      });
    }
  }

  document.querySelectorAll('.aa-finder').forEach((finder) => {
    Object.setPrototypeOf(finder, AARecordStorageFinder.prototype);
    finder.connectedCallback();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  const track = (eventName, parameters = {}) => {
    const shopifyEventName = `atelier_article:${eventName}`;
    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish === 'function') {
      Promise.resolve(publish(shopifyEventName, parameters)).catch(() => {});
    }
    if (!window.dataLayer) window.dataLayer = [];
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: eventName, ...parameters });
    }
  };

  const initialize = (tool) => {
    if (tool.dataset.aaSpacePreviewReady === 'true') return;
    tool.dataset.aaSpacePreviewReady = 'true';

    const monthlySelect = tool.querySelector('[data-aa-growth-monthly]');
    const levelInputs = [...tool.querySelectorAll('[data-aa-growth-levels]')];
    const inchesOutput = tool.querySelector('[data-aa-growth-inches]');
    const cmOutput = tool.querySelector('[data-aa-growth-cm]');
    const recordsOutput = tool.querySelector('[data-aa-growth-records]');
    const levelCountOutput = tool.querySelector('[data-aa-growth-level-count]');
    const levelOne = tool.querySelector('[data-aa-growth-level-one]');
    const levelMany = tool.querySelector('[data-aa-growth-level-many]');
    const ruler = tool.querySelector('[data-aa-growth-ruler]');
    const capacityLink = tool.querySelector('[data-aa-growth-capacity-link]');

    if (!monthlySelect || !levelInputs.length || !inchesOutput || !cmOutput || !recordsOutput || !levelCountOutput || !ruler) return;

    const calculate = (shouldTrack = false) => {
      const monthlyRecords = Number(monthlySelect.value);
      const levels = Number(levelInputs.find((input) => input.checked)?.value || 1);
      const annualRecords = monthlyRecords * 12;
      const inches = annualRecords / (5 * levels);
      const centimeters = Math.round(inches * 2.54);
      const displayedInches = inches.toFixed(1).replace('.0', '');
      const progress = Math.min(100, (inches / 48) * 100);

      inchesOutput.value = displayedInches;
      inchesOutput.textContent = displayedInches;
      cmOutput.value = String(centimeters);
      cmOutput.textContent = String(centimeters);
      recordsOutput.textContent = String(annualRecords);
      levelCountOutput.textContent = String(levels);
      levelOne.hidden = levels !== 1;
      levelMany.hidden = levels === 1;
      ruler.style.setProperty('--aa-space-preview-progress', `${progress}%`);

      if (shouldTrack) {
        track('aa_space_preview_changed', {
          monthly_records: monthlyRecords,
          storage_levels: levels,
          annual_records: annualRecords,
          additional_width_inches: Number(displayedInches),
          additional_width_cm: centimeters
        });
      }
    };

    monthlySelect.addEventListener('change', () => calculate(true));
    levelInputs.forEach((input) => input.addEventListener('change', () => calculate(true)));
    capacityLink?.addEventListener('click', () => {
      track('aa_space_preview_capacity_clicked', {
        monthly_records: Number(monthlySelect.value),
        storage_levels: Number(levelInputs.find((input) => input.checked)?.value || 1)
      });
    });

    calculate(false);
    track('aa_space_preview_shown', {
      monthly_records: Number(monthlySelect.value),
      storage_levels: Number(levelInputs.find((input) => input.checked)?.value || 1)
    });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-aa-space-preview]').forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
